<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="number">Номер дома</label>
    <input
      type="text"
      class="form-control"
      id="number"
      placeholder="Введите номер"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'building-number-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BuildingNumber.vue?31bbbdf4